{
  "cp.components.appDrawer.drawerCourses": "Kurssit",
  "cp.components.appDrawer.drawerExport": "Vie",
  "cp.components.appDrawer.drawerImprint": "Käyttöehdot",
  "cp.components.appDrawer.drawerInstitutes": "Instituutiot",
  "cp.components.appDrawer.drawerSettings": "Asetukset",
  "cp.components.appDrawer.drawerShares": "Osakkeet",
  "cp.components.appDrawer.drawerSingleTrainings": "Harjoitukset",
  "cp.components.appDrawer.drawerTrainees": "Harjoittelijat",
  "cp.components.appDrawer.drawerTrainers": "Kouluttajat",
  "cp.components.changePassword.changePasswordButton": "Vaihda salasana",
  "cp.components.changePassword.currentPassword": "Nykyinen salasana",
  "cp.components.changePassword.equalError": "Uusi salasana on sama kuin vanha",
  "cp.components.changePassword.matchError": "Uudet salasanat eivät täsmää",
  "cp.components.changePassword.newPassword": "Uusi salasana",
  "cp.components.changePassword.newPasswordRepeat": "Uusi salasana (toista)",
  "cp.components.changePassword.newRequiredError": "Uusi salasana vaaditaan",
  "cp.components.changePassword.newToShortError": "Annettu salasana on liian lyhyt.",
  "cp.components.changePassword.requiredError": "Nykyinen salasana vaaditaan",
  "cp.components.changePassword.setPasswordButton": "Aseta salasana",
  "cp.components.changeUserRole.errorSnackbar": "Tapahtui Tuntematon virhe. Yritä uudelleen tai ota yhteyttä tukeen, jos virhe ei poistu.",
  "cp.components.changeUserRole.selectLabel": "Valitse rooli",
  "cp.components.changeUserRole.successSnackbar": "Muutettu rooli muotoon {role}",
  "cp.components.courseTable.deleteLabel": "poista",
  "cp.components.courseTable.downloadCSVTitle": "Lataa CSV-tiedosto",
  "cp.components.courseTable.downloadMessage": "Kurssi valittu ladattavaksi",
  "cp.components.courseTable.selected": "valittu",
  "cp.components.courseTable.tableRowAssociatedTrainer": "Liittyvä kouluttaja",
  "cp.components.courseTable.tableRowDate": "Päivämäärä",
  "cp.components.courseTable.tableRowIdentifier": "Kurssin tunnus",
  "cp.components.courseTable.tableRowLocation": "Sijainti",
  "cp.components.courseTable.tableRowProvider": "Koulutuksen tarjoaja",
  "cp.components.courseTable.tableRowTraineeCount": "Harjoittelijien määrä",
  "cp.components.courseTable.tableRowValue": "Arvo",
  "cp.components.dialog.confirmDeletion.contentConclusion": "Poisto on pysyvä. Tämä tili ei ole enää käytettävissä.",
  "cp.components.dialog.confirmDeletion.contentDescription": "Olet poistamassa tilin, jolla on seuraavat roolit:",
  "cp.components.dialog.confirmDeletion.title": "Poista valittu tili?",
  "cp.components.footer.rightsReserved": "Kaikki oikeudet pidätetään.",
  "cp.components.general.institutePageSnackbarError": "Virhe instituutiota tallennettaessa",
  "cp.components.general.institutePageSnackbarSuccess": "Tallennettu",
  "cp.components.general.snackbar.emailAllreadySentSnackbar": "Sähköposti on lähetetty viimeisen 10 minuutin aikana. Odota, ennen kuin voit lähettää toisen.",
  "cp.components.general.tableRowName": "Nimi",
  "cp.components.genericTable.emptyMessage": "Tyhjä",
  "cp.components.genericTable.multiSelect": "valitse kaikki",
  "cp.components.genericTable.nextPage": "seuraava sivu",
  "cp.components.genericTable.previousPage": "edellinen sivu",
  "cp.components.genericTable.rowsPerPageLabel": "Rivit per sivu:",
  "cp.components.genericTable.searchPlaceholder": "Haku",
  "cp.components.imprint.pageTitle": "Käyttöehdot",
  "cp.components.instituteAdminTable.adminsTableEmail": "Email",
  "cp.components.instituteAdminTable.adminsTableInviteButton": "Kutsu ylläpitäjä",
  "cp.components.instituteAdminTable.adminsTableSubtitle": "Käyttäjät oikeutettuja hallinnoimaan instituutiota",
  "cp.components.instituteAdminTable.adminsTableTitle": "Järjestelmänvalvojat",
  "cp.components.instituteAdminTable.deleteAdminMessage": "Haluatko todella poistaa valitun järjestelmänvalvojan? Tämä on pysyvä.",
  "cp.components.instituteAdminTable.deleteLabel": "poista",
  "cp.components.instituteAdminTable.deleteTrainerMessage": "Haluatko todella poistaa valitun kouluttajan? Tämä on pysyvää.",
  "cp.components.instituteAdminTable.name": "Nimi",
  "cp.components.instituteAdminTable.selected": "valittu",
  "cp.components.instituteForm.institute": "Instituutio",
  "cp.components.instituteForm.instituteAddress": "Instituution osoite",
  "cp.components.instituteForm.instituteCity": "Kaupunki",
  "cp.components.instituteForm.instituteCountry": "Maa",
  "cp.components.instituteForm.instituteName": "Instituution nimi",
  "cp.components.instituteForm.instituteSaveButton": "Tallenna",
  "cp.components.instituteForm.instituteState": "Maa",
  "cp.components.instituteForm.instituteStreet": "Katu ja tien numero",
  "cp.components.instituteForm.instituteStreetAdditional": "Lisäys osoitteeseen",
  "cp.components.instituteForm.instituteZIP": "Postinumero",
  "cp.components.instituteForm.localeDanish": "Dansk",
  "cp.components.instituteForm.localeEnglish": "English",
  "cp.components.instituteForm.localeFinish": "Suomi",
  "cp.components.instituteForm.localeFrench": "Français",
  "cp.components.instituteForm.localeGerman": "Deutsch",
  "cp.components.instituteForm.localeItalian": "Italiano",
  "cp.components.instituteForm.localeLabel": "Kieli",
  "cp.components.instituteForm.localeSpanish": "Espanol",
  "cp.components.instituteResultConfig.button": "Konfiguroi tuloksen palaute",
  "cp.components.instituteResultConfig.info": "Näitä muutoksia sovelletaan koko instituuttiin. Jotta tämä tapahtuisi, kouluttajien on kirjauduttava uudelleen CorPatch® Kouluttaja -sovellukseen. ",
  "cp.components.instituteResultConfig.save": "Tallenna Konfiguraatio",
  "cp.components.instituteResultConfig.thresholdGood": "Kynnysarvo Hyvä",
  "cp.components.instituteResultConfig.thresholdGreat": "Kynnysarvo Suuri",
  "cp.components.instituteTrainerTable.button": "Kutsu Kouluttaja",
  "cp.components.instituteTrainerTable.deleteLabel": "poista",
  "cp.components.instituteTrainerTable.name": "Name",
  "cp.components.instituteTrainerTable.selected": "valittu",
  "cp.components.instituteTrainerTable.subtitle": "Kaikki instituutioon kuuluvat kouluttajat",
  "cp.components.instituteTrainerTable.tableRowsStreet": "Katu",
  "cp.components.instituteTrainerTable.title": "Kouluttajat",
  "cp.components.instituteTrainerTable.trainerEmptyMessage": "Ei kouluttajia vielä",
  "cp.components.invite.inviteCancelButton": "Peru",
  "cp.components.invite.inviteEmailRequired": "Email",
  "cp.components.invite.inviteEmailSend": "Lähetetty",
  "cp.components.invite.inviteEmailSent": "Sähköposti lähetetty.",
  "cp.components.invite.inviteFirstnameLabel": "Etunimi",
  "cp.components.invite.inviteInvalidEmail": "Tämä ei ole kelvollinen sähköpostiosoite",
  "cp.components.invite.inviteOk": "OK",
  "cp.components.invite.inviteSendButton": "Lähetä kutsu",
  "cp.components.invite.inviteSubheader": "Kutsu lähetetään tähän sähköpostiosoitteeseen.",
  "cp.components.invite.inviteSurnameLabel": "Sukunimi",
  "cp.components.navBar.menuLabel": "Valikko",
  "cp.components.passwordForgotSetPassword.changePasswordButton": "Vaihda salasana",
  "cp.components.passwordForgotSetPassword.matchError": "Uudet salasanat eivät täsmää",
  "cp.components.passwordForgotSetPassword.newPassword": "Uusi salasana",
  "cp.components.passwordForgotSetPassword.newPasswordRepeat": "Uusi salasana (toista)",
  "cp.components.passwordForgotSetPassword.newRequiredError": "Uusi salasana vaaditaan",
  "cp.components.passwordForgotSetPassword.newToShortError": "Annettu salasana on liian lyhyt.",
  "cp.components.reminder.app.appAppStoreButton": "Mene Apple App Storeen",
  "cp.components.reminder.app.appPlayStoreButton": "Mene Google Play -kauppaan",
  "cp.components.reminder.app.content": "CorPatch® -laitteen käyttämiseen tarvitaan CorPatch® -sovellus. Lataa se Google Playstoresta tai App Storesta. \n",
  "cp.components.reminder.app.title": "Haluatko aloittaa? Lataa sovellus!",
  "cp.components.reminder.title": "CorPatch®",
  "cp.components.reminder.welcome": "Tervetuloa",
  "cp.components.resetPassword.changePasswordButton": "Vaihda salasana",
  "cp.components.resetPassword.currentPassword": "Nykyinen salasana",
  "cp.components.resetPassword.equalError": "Uusi salasana on sama kuin vanha",
  "cp.components.resetPassword.matchError": "Uudet salasanat eivät täsmää",
  "cp.components.resetPassword.newPassword": "Uusi salasana",
  "cp.components.resetPassword.newPasswordRepeat": "Uusi salasana (toista)",
  "cp.components.resetPassword.newRequiredError": "Uusi salasana vaaditaan",
  "cp.components.resetPassword.requiredError": "Nykyinen salasana vaaditaan",
  "cp.components.resetPassword.setPasswordButton": "Aseta salasana",
  "cp.components.singleTrainingsTable.shareDialogContent": "Valitse oppilaitos, jonka kanssa haluat jakaa tämän koulutuksen:",
  "cp.components.singleTrainingsTable.shareDialogTitle": "Jaa koulutus",
  "cp.components.singleTrainingsTable.shareDialogTooltip": "Jaa koulutus",
  "cp.components.singleTrainingsTable.sharedDialogCancelButton": "Peru",
  "cp.components.singleTrainingsTable.sharedDialogShareButton": "Jaa",
  "cp.components.singleTrainingsTable.sharedDialogTooltip": "Jaettu osoitteessa: ",
  "cp.components.singleTrainingsTable.tableRowDate": "Pvm",
  "cp.components.singleTrainingsTable.tableRowDepth": "Syvyys",
  "cp.components.singleTrainingsTable.tableRowFlow": "Virtaus",
  "cp.components.singleTrainingsTable.tableRowFrequency": "Taajuus",
  "cp.components.singleTrainingsTable.tableRowOrigin": "Harjoitus",
  "cp.components.singleTrainingsTable.tableRowRecoil": "Rintakehän palautuminen",
  "cp.components.singleTrainingsTable.tableShareTrainingTooltip": "Jaa koulutus",
  "cp.components.userMenu.email": "Email",
  "cp.components.userMenu.logout": "Kirjaudu ulos",
  "cp.components.userMenu.password": "Salasana",
  "cp.pages.acceptInvitation.button": "Kirjautumissivulle",
  "cp.pages.acceptInvitation.message": "Kaikki on valmista ja voit aloittaa!",
  "cp.pages.acceptInvitation.pageNotFound.message": "Tämä kutsu ei ole enää voimassa.",
  "cp.pages.acceptInvitation.pageNotFound.title": "Kutsua ei löydy",
  "cp.pages.acceptInvitation.title": "Valmista.",
  "cp.pages.acceptInvitation.welcome": "Tervetuloa",
  "cp.pages.adminInvite.errorSnackbar": "Sähköposti {email} on jo käytössä",
  "cp.pages.adminInvite.inviteCardTitle": "Kutsu ylläpitäjä",
  "cp.pages.adminInvite.successSnackbar": "Sähköposti lähetetty {email}",
  "cp.pages.admins.adminsEmpty.button": "Kutsu ylläpitäjä",
  "cp.pages.admins.adminsEmpty.message": "Haluatko kutsua ensimmäisen instituution ylläpitäjän?",
  "cp.pages.admins.adminsEmpty.selected": "valittu",
  "cp.pages.admins.adminsEmpty.tableRowEmail": "Sähköposti",
  "cp.pages.admins.adminsEmpty.tableRowName": "Nimi",
  "cp.pages.admins.adminsEmpty.title": "Ei vielä ylläpitäjiä!",
  "cp.pages.admins.adminsNotFound.message": "Tämä instituutio on poistettu. ",
  "cp.pages.admins.adminsNotFound.title": "Ei löytynyt!",
  "cp.pages.admins.instituteAdmin": "Institute Admin",
  "cp.pages.admins.tableRowInstitute": "Instituutio",
  "cp.pages.admins.title": "Admins",
  "cp.pages.course.cellDate": "Pvm",
  "cp.pages.course.cellDuration": "Kesto",
  "cp.pages.course.cellFeedback": "Palaute",
  "cp.pages.course.cellName": "Nimi",
  "cp.pages.course.rowDepth": "Syvyys",
  "cp.pages.course.rowFlow": "Flow",
  "cp.pages.course.rowFrequency": "Taajuus",
  "cp.pages.course.rowRecoil": "Rintakehän palautuminen",
  "cp.pages.course.title": "Kurssi",
  "cp.pages.course.trainees": "Harjoittelijat",
  "cp.pages.courses.errorSnackbar": "Tätä kurssia ei voitu poistaa.",
  "cp.pages.courses.pageNotFoundMessage": "Poistettiin. Anteeksi :(",
  "cp.pages.courses.pageNotFoundTitle": "ei löytynyt",
  "cp.pages.courses.pageTitle": "Kurssit",
  "cp.pages.courses.roleInstituteAdmin": "Instituution ylläpitäjä",
  "cp.pages.courses.roleTrainee": "Harjoittelija",
  "cp.pages.courses.successSnackbar": "Kurssi on poistettu onnistuneesti.",
  "cp.pages.dashboard.cpsCount": "aktiiviset CorPatch® -laitteet",
  "cp.pages.dashboard.cpsCountRecently": "uusi CorPatch® yhdistetty",
  "cp.pages.dashboard.lastMonth": "Kehitys viimeisen kuukauden aikana.",
  "cp.pages.dashboard.mobilesCount": "Kaikki matkapuhelimet tunnistettu",
  "cp.pages.dashboard.mobilesCountRecently": "viimeksi havaitut uudet mobiilit",
  "cp.pages.dashboard.pageTitle": "Tilastot",
  "cp.pages.dashboard.trainingsCount": "suoritetut harjoitukset",
  "cp.pages.dashboard.usersCount": "rekisteröityneiden käyttäjien kokonaismäärä",
  "cp.pages.dashboard.usersCountRecently": "rekisteröityjä uusia käyttäjiä",
  "cp.pages.email.validation.button": "Mene sisäänkirjautumiseen",
  "cp.pages.email.validation.text": "Kiitos sähköpostiosoitteesi vahvistamisesta. Käytämme sitä pitämään tilisi turvassa ja pitämään sinut ajan tasalla, jos haluat.",
  "cp.pages.export.pageTitle": "Vie kurssi",
  "cp.pages.homepage.title": "Kotisivu",
  "cp.pages.institute.PageNotFound.message": "Kyseinen instituutio on poistettu eikä sitä voida muokata enää.",
  "cp.pages.institute.PageNotFound.title": "Instituutiota ei löydy.",
  "cp.pages.institute.institute": "Instituutio",
  "cp.pages.institute.snackbarError": "Virhe instituutiota tallennettaessa",
  "cp.pages.institute.snackbarSuccess": "Tallennettu",
  "cp.pages.institute.tabsAdmins": "Ylläpitäjät",
  "cp.pages.institute.tabsBaseData": "Perusdata",
  "cp.pages.institute.tabsTrainers": "Ohjaaja",
  "cp.pages.instituteAdminShares.active": "Active",
  "cp.pages.instituteAdminShares.deleted": "Deleted",
  "cp.pages.instituteAdminShares.endDate": "Loppu: ",
  "cp.pages.instituteAdminShares.noActiveSharingObjectsMessage": "Sinulla ei ole aktiivisia jakamisobjekteja.",
  "cp.pages.instituteAdminShares.noDeletedSharingObjectsMessage": "Ei poistettuja jakamisobjekteja.",
  "cp.pages.instituteAdminShares.pageNotFoundMessage": "Hakemasi osakkeet eivät ole olemassa.",
  "cp.pages.instituteAdminShares.pageTitle": "Julkaisut",
  "cp.pages.instituteAdminShares.pageTitleNotFound": "Ei löytynyt",
  "cp.pages.instituteAdminShares.startDate": "Aloita: ",
  "cp.pages.institutes.addInstituteButton": "Lisää instituutio",
  "cp.pages.institutes.deleteLabel": "poista",
  "cp.pages.institutes.errorSnackbar": "Instituutiota ei voitu poistaa",
  "cp.pages.institutes.pageNotFound.message": "Haluatko lisätä ensimmäisen instituution?",
  "cp.pages.institutes.pageNotFound.title": "Instituutiota ei löytynyt",
  "cp.pages.institutes.pageTitle": "Instituutiot",
  "cp.pages.institutes.successSnackbar": "Instituutio poistettiin onnistuneesti",
  "cp.pages.institutesTable.deleteWarning": "Haluatko poistaa valitun instituution? Kaikki siihen liittyvä tieto poistetaan.",
  "cp.pages.institutesTable.instituteLowercase": "instituutio",
  "cp.pages.institutesTable.institutesLowercase": "instituutiot",
  "cp.pages.institutesTable.tableRowCity": "Kaupunki",
  "cp.pages.institutesTable.tableRowCountry": "Maa",
  "cp.pages.institutesTable.tableRowInstitutes": "Instituutiot",
  "cp.pages.institutesTable.tableRowName": "Nimi",
  "cp.pages.institutesTable.tableRowStreet": "Katu",
  "cp.pages.institutesTable.tableRowZIP": "Postinumero",
  "cp.pages.internalServerError.button": "Yritä uudelleen",
  "cp.pages.internalServerError.message": "Palvelin ei voinut suorittaa pyyntöä. Yritä uudelleen myöhemmin.",
  "cp.pages.internalServerError.title": "Yritä myöhemmin uudelleen.",
  "cp.pages.login.email": "Sähköposti",
  "cp.pages.login.loginButton": "Kirjaudu sisään",
  "cp.pages.login.loginInstitutesTitle": "Instituutiot",
  "cp.pages.login.password": "Salasana",
  "cp.pages.login.passwordForgot": "Unohtuiko salasana?",
  "cp.pages.login.registerButton": "Rekisteröidy",
  "cp.pages.login.termsOfUseButton": "käyttöehdot",
  "cp.pages.login.userNewlyRegisteredLabel1": "Sinut on rekisteröity onnistuneesti.",
  "cp.pages.login.userNewlyRegisteredLabel2": "Älä unohda vahvistaa e-Mail -osoitettasi ja kirjaudutua heti sisään.",
  "cp.pages.login.userOrPasswordNotFound": "Käyttäjätunnusta tai salasanaa ei löytynyt",
  "cp.pages.login.validate.errorContent": "Ehkä olet yrittänyt kirjautua sisään toisesta selaimesta tai laitteesta tai olet sulkenut selaimesi sillä välin. Yritä pyytää toista sähköpostiosoitetta kirjautumiseen.",
  "cp.pages.login.validate.errorSnackbar": "Kirjautuessasi sisään tapahtui virhe. Linkkisi saattaa olla vanhentunut.",
  "cp.pages.login.validate.errorTitle": "Emme tunnistaneet selainistuntoasi",
  "cp.pages.login.validate.successContent": "Odota hetki, kun vahvistamme kirjautumistunnuksesi.",
  "cp.pages.login.validate.successTitle": "Kirjaamme sinut sisään.",
  "cp.pages.login.validate.validationButton": "Palaa kirjautumiseen",
  "cp.pages.login.validate.validationContent": "Olemme lähettäneet sinulle sähköpostiviestin kirjautumistunnuksesi vahvistamiseksi.",
  "cp.pages.login.validate.validationTitle": "Varmista kirjautumistunnuksesi",
  "cp.pages.logout.loginButton": "Kirjaudu sisään",
  "cp.pages.logout.message": "Nähdään ensi kerralla",
  "cp.pages.logout.title": "Näkemiin!",
  "cp.pages.me.deleteOwnButtonConfirm": "Poista tilisi pysyvästi",
  "cp.pages.me.deleteOwnButtonRequest": "Poista tilisi pysyvästi",
  "cp.pages.me.deleteOwnContent": "Tämä toimenpide poistaa tilisi pysyvästi. Huomioithan että olet tallentanut kaiken tiedon jotka voivat hävitä kun poistat tilisi. Tätä toimenpidettä ei voi perua jälkikäteen.",
  "cp.pages.me.familyName": "Sukunimi",
  "cp.pages.me.firstName": "Etunimi",
  "cp.pages.me.gender": "Sukupuoli",
  "cp.pages.me.genderFemale": "Nainen",
  "cp.pages.me.genderMale": "Mies",
  "cp.pages.me.genderOther": "Muu",
  "cp.pages.me.notFoundTitle": "Henkilökohtaiset asetukset",
  "cp.pages.me.save": "Tallenna",
  "cp.pages.me.snackBarSaved.error": "Virhe tallennettaessa henkilökohtaisia asetuksia",
  "cp.pages.me.snackBarSaved.saved": "Tallennettu",
  "cp.pages.me.title": "Henkilökohtaiset asetukset",
  "cp.pages.networkError.pageNotFound.button": "Yritä uudelleen",
  "cp.pages.networkError.pageNotFound.message": "Palvelin ei voinut suorittaa pyyntöä. Oletko yhdistettynä Internetiin?",
  "cp.pages.networkError.pageNotFound.title": "Palvelin näyttää olevan alhaalla. Tämän hoidamme me! Yritä myöhemmin uudelleen. ",
  "cp.pages.notFound.message": "Tätä sivua ei löytynyt.",
  "cp.pages.notFound.title": "Ei löytynyt.",
  "cp.pages.passwordForgot.confirmationMessage": "Vahvistussähköposti lähetetään tilillesi.",
  "cp.pages.passwordForgot.confirmationMessage2": "Tarkistathan sen.",
  "cp.pages.passwordForgot.confirmationSendMessage": "Lähetimme sinulle sähköpostin, joka sisältää linkin hyväksymistä varten henkilölle:",
  "cp.pages.passwordForgot.confirmationSent": "Lähetä sähköposti",
  "cp.pages.passwordForgot.confirmationTitle": "Nollaa salasanasi",
  "cp.pages.passwordForgot.eMail": "Sähköposti",
  "cp.pages.passwordForgot.passwordForgotBackToLogin": "Takaisin sisäänkirjautumiseen",
  "cp.pages.passwordForgot.passwordForgotTitle": "Salasana unohtunut",
  "cp.pages.passwordForgotSetPassword.button": "Kirjautumissivulle",
  "cp.pages.passwordForgotSetPassword.message": "Kaikki tehty ja voit aloittaa!",
  "cp.pages.passwordForgotSetPassword.pageNotFound.message": "Tämä koodi ei ole enää voimassa.",
  "cp.pages.passwordForgotSetPassword.pageNotFound.title": "Ei enää voimassa",
  "cp.pages.passwordForgotSetPassword.title": "Salasana vaihdettu!",
  "cp.pages.passwordForgotSetPassword.welcome": "Tervetuloa",
  "cp.pages.register.acceptTermsOfUse": "Hyväksytkö käyttöehdot?",
  "cp.pages.register.create": "Luo tili",
  "cp.pages.register.emailField": "Sähköposti",
  "cp.pages.register.errorSnackbar": "Tapahtui tahaton virhe. Yritä uudelleen.",
  "cp.pages.register.firstnameField": "Etunimi",
  "cp.pages.register.lastnameField": "Sukunimi",
  "cp.pages.register.newToShortError": "Annettu salasana on liian lyhyt.",
  "cp.pages.register.passwordField": "salasana",
  "cp.pages.register.successSnackbar": "Rekisteröintisi onnistui.",
  "cp.pages.settings.feedbackMode.menuItemExpert": "Palkki",
  "cp.pages.settings.feedbackMode.menuItemNone": "Ei mikään",
  "cp.pages.settings.feedbackMode.menuItemSimple": "Pumppu",
  "cp.pages.settings.menuItemThresholdGood": "Kynnysarvon palaute \"Hyvä\"",
  "cp.pages.settings.menuItemThresholdGreat": "Kynnysarvon palaute \"Erinomainen\"",
  "cp.pages.settings.resultType.menuItemExpert": "Asiantuntija",
  "cp.pages.settings.resultType.menuItemNone": "Ei mikään",
  "cp.pages.settings.resultType.menuItemSimple": "Yksinkertainen",
  "cp.pages.settings.resultType.menuItemStandard": "Vakio",
  "cp.pages.settings.tableRowCompression": "Vain painelut",
  "cp.pages.settings.tableRowDuration": "Istunnon kesto",
  "cp.pages.settings.tableRowERC": "Tarkista vitaalit",
  "cp.pages.settings.tableRowFeedback": "Palaute moodi",
  "cp.pages.settings.tableRowFrequency": "Tavoitetaajuus",
  "cp.pages.settings.tableRowLocked": "Lukittu",
  "cp.pages.settings.tableRowProperty": "Omaisuus",
  "cp.pages.settings.tableRowResult": "Tuloksen tyyppi",
  "cp.pages.settings.tableRowResultConfigSaveButton": "Tallenna tuloksen konfiguraatio",
  "cp.pages.settings.tableRowSaveButton": "Tallenna",
  "cp.pages.settings.tableRowTrainees": "Ohjattavien oletuslukumäärä",
  "cp.pages.settings.tableRowType": "Harjoituksen tyyppi",
  "cp.pages.settings.tableRowValue": "Arvo",
  "cp.pages.settings.title": "CorPatch® Kouluttaja asetukset",
  "cp.pages.sharingObject.form.apiAccess": "API-käyttöoikeus",
  "cp.pages.sharingObject.form.confirmDeleteDialogMessage1": "Haluatko varmasti poistaa jakamisobjektin?",
  "cp.pages.sharingObject.form.confirmDeleteDialogMessage2": "Tätä toimintoa ei voi kumota, mutta tietoja ei menetetä. Jakamisobjekti näytetään deaktivoituna.",
  "cp.pages.sharingObject.form.confirmDeleteDialogNo": "Peru",
  "cp.pages.sharingObject.form.confirmDeleteDialogTitle": "Poista jakamisobjekti",
  "cp.pages.sharingObject.form.confirmDeleteDialogYes": "Poista",
  "cp.pages.sharingObject.form.deleteButton": "Poista",
  "cp.pages.sharingObject.form.disabled": "Poistettu käytöstä",
  "cp.pages.sharingObject.form.enabled": "Käytössä",
  "cp.pages.sharingObject.form.invitationCode": "Kutsun koodi",
  "cp.pages.sharingObject.form.invitationLink": "Kutsu Link",
  "cp.pages.sharingObject.form.name": "Nimi",
  "cp.pages.sharingObject.form.pullApiSecret": "Salaisuus",
  "cp.pages.sharingObject.form.pullUrl": "Pull URL",
  "cp.pages.sharingObject.form.saveButton": "Tallenna",
  "cp.pages.sharingObject.form.title": "Jakaminen objekti",
  "cp.pages.sharingObject.form.webHook": "WebKoukku",
  "cp.pages.sharingObject.pageNotFoundDescription": "Etsimäsi jakamisobjektit eivät ole olemassa.",
  "cp.pages.sharingObject.pageNotFoundTitle": "Ei löytynyt",
  "cp.pages.sharingObject.pageTitle": "Objektien jakaminen",
  "cp.pages.sharingObject.snackBarDeleteError": "Ei voitu poistaa",
  "cp.pages.sharingObject.snackBarDeleted": "Poistettu",
  "cp.pages.sharingObject.snackBarSaveError": "Ei voinut säästää",
  "cp.pages.sharingObject.snackBarSaved": "Tallennettu",
  "cp.pages.singleTraining.multipleTrainings": "harjoitukset",
  "cp.pages.singleTraining.singleTraining": "harjoitus",
  "cp.pages.singleTraining.table.created": "Luotu",
  "cp.pages.singleTraining.table.name": "Koko nimi",
  "cp.pages.singleTraining.table.selected": "valitut",
  "cp.pages.singleTraining.title": "Harjoituksesi",
  "cp.pages.trainee.cpsButton": "Lataa CorPatch®-data",
  "cp.pages.trainee.delete.errorSnackbar": "Tuntematon virhe tapahtui",
  "cp.pages.trainee.delete.successSnackbar": "Harjoittelijat poistettu onnistuneesti",
  "cp.pages.trainee.delete.warningSnackbar": "Yhtä tai useampaa käyttäjää ei poistettu",
  "cp.pages.trainee.deleteDialogButtonPrimary": "Poista",
  "cp.pages.trainee.deleteDialogButtonSecondary": "Sulje",
  "cp.pages.trainee.deleteLabel": "poista",
  "cp.pages.trainee.mobileButton": "Älypuhelimen tietojen lataus",
  "cp.pages.trainee.multipleTrainees": "ohjattavat",
  "cp.pages.trainee.singleTrainee": "ohjattava",
  "cp.pages.trainee.table.created": "Luotu",
  "cp.pages.trainee.table.email": "Sähköposti",
  "cp.pages.trainee.table.name": "Koko nimi",
  "cp.pages.trainee.table.selected": "valitut",
  "cp.pages.trainee.title": "Ohjattavat",
  "cp.pages.traineeShares.active": "Aktiivinen",
  "cp.pages.traineeShares.addDialogAdd": "Lisää",
  "cp.pages.traineeShares.addDialogCancel": "Peru",
  "cp.pages.traineeShares.addDialogDescription": "Anna kumppaniorganisaatiostasi saamasi kutsukoodi:",
  "cp.pages.traineeShares.addDialogDescription2": "Jos valitset \"Lisää\", vahvistat hyväksyväsi ehdot ja tietosuojakäytännöt, jotka kumppaniorganisaatio on toimittanut sinulle yhdessä kutsulinkin/koodin kanssa. On tärkeää, että luet ja ymmärrät nämä ennen jatkamista.",
  "cp.pages.traineeShares.addDialogTitle": "Kutsu",
  "cp.pages.traineeShares.addShare": "Lisää julkaisu",
  "cp.pages.traineeShares.deactivateDialogDescription": "Haluatko varmasti poistaa tämän jakamissopimuksen käytöstä {instituteName} kanssa?",
  "cp.pages.traineeShares.deactivateDialogNo": "Peru",
  "cp.pages.traineeShares.deactivateDialogTitle": "Poista aktivointi",
  "cp.pages.traineeShares.deactivateDialogYes": "Poista aktivointi",
  "cp.pages.traineeShares.deactivateTooltip": "Poista aktivointi",
  "cp.pages.traineeShares.endDate": "Lopetuspäivä: ",
  "cp.pages.traineeShares.inactive": "Epäaktiivinen",
  "cp.pages.traineeShares.noActiveItemsMessage": "Tällä hetkellä, et ole hyväksynyt mitään tietojen jakamista koskevia sopimuksia. Kirjoita vastaava kutsukoodi painamalla oikeassa alakulmassa olevaa pluspainiketta.",
  "cp.pages.traineeShares.noInactiveItemsMessage": "Ei aktiivisia jakamissopimuksia.",
  "cp.pages.traineeShares.pageNotFoundMessage": "Hakemasi harjoittelijan osakkeita ei ole olemassa.",
  "cp.pages.traineeShares.pageTitle": "Harjoittelijoiden julkaisut",
  "cp.pages.traineeShares.pageTitleNotFound": "Ei löytynyt",
  "cp.pages.traineeShares.snackBarErrorAddingInvitation": "Virhe kutsun lisäämisessä: {errorMessage}!",
  "cp.pages.traineeShares.snackBarErrorDeactivatingSharing": "Virhe jakamisen deaktivoinnin poistamisessa: {errorMessage}!",
  "cp.pages.traineeShares.snackBarInvalidCode": "Anna kelvollinen kutsukoodi.",
  "cp.pages.traineeShares.snackBarInvitationAdded": "Kutsu lisätty",
  "cp.pages.traineeShares.snackBarSharingDeactivated": "Jakaminen pois käytöstä",
  "cp.pages.traineeShares.startDate": "Aloituspäivämäärä: ",
  "cp.pages.trainerInvite.errorSnackbar": "Sähköposti on jo käytössä",
  "cp.pages.trainerInvite.successSnackbar": "Sähköposti lähetetty osoitteeseen {email}",
  "cp.pages.trainerInvite.title": "Kutsu kouluttaja",
  "cp.pages.trainers.errorSnackbar": "Käyttäjää ei voitu poistaa. Yritä uudelleen!",
  "cp.pages.trainers.successSnackbar": "Poistettu",
  "cp.pages.trainersNotAvailable.button": "Kutsu kouluttaja",
  "cp.pages.trainersNotAvailable.message": "Haluatko kutsua ensimmäisen kouluttajan?",
  "cp.pages.trainersNotAvailable.title": "Ei vielä kouluttajia!",
  "cp.pages.trainersNotFound.message": "Tämä kouluttaja on poistettu. Anteeksi :(",
  "cp.pages.trainersNotFound.title": "Kouluttajaa ei löydy",
  "cp.pages.trainersTable.deleteLabel": "poista",
  "cp.pages.trainersTable.inviteTrainer": "Kutsu kouluttaja",
  "cp.pages.trainersTable.selected": "valittu",
  "cp.pages.trainersTable.tableRowEmail": "Sähköposti",
  "cp.pages.trainersTable.tableRowName": "Nimi",
  "cp.pages.trainersTable.trainers": "Kouluttajat",
  "cp.pages.trainings.depth": "Depth",
  "cp.pages.trainings.flow": "Flow",
  "cp.pages.trainings.frequency": "Frequency",
  "cp.pages.trainings.notFound.message": "Has been deleted already. Sorry.",
  "cp.pages.trainings.notFound.title": "Not found",
  "cp.pages.trainings.recoil": "Recoil",
  "cp.pages.trainings.title": "Trainings",
  "cp.pages.trainings.trainee": "Trainee",
  "cp.pages.trainings.trainingNumber": "Training No.",
  "cp.pages.userChangeEmail.cancelButton": "Peru",
  "cp.pages.userChangeEmail.changeEmail": "Vaihda sähköposti",
  "cp.pages.userChangeEmail.email": "Email",
  "cp.pages.userChangeEmail.emailChangedSnackbar": "Sähköposti vaihdettu",
  "cp.pages.userChangeEmail.emailErrorSnackbar": "Sähköpostia ei voitu muuttaa",
  "cp.pages.userChangeEmail.newEmail": "Uusi sähköposti",
  "cp.pages.userChangeEmail.notFound.message": "Tätä käyttäjää ei enää ole.",
  "cp.pages.userChangeEmail.notFound.title": "Ei löydetty.",
  "cp.pages.userChangeEmail.ok": "OK",
  "cp.pages.userChangeEmail.sendEmail": "Sähköposti lähetetty",
  "cp.pages.userChangeEmail.verifyEmail.button": "Lähetä minulle uusi vahvistus sähköpostiini",
  "cp.pages.userChangeEmail.verifyEmail.content": "Haluamme pitää sinut ajan tasalla sovelluksemme ja tuotteidemme uusimmista muutoksista.Tämän vuksi meidän on vahvistettava sähköpostiosoitteesi.",
  "cp.pages.userChangeEmail.verifyEmail.title": "Vahvista sähköpostiosoitteesi",
  "cp.pages.userChangePassword.notChangedPasswordSnackbar": "Salasanaa ei voi muuttaa:",
  "cp.pages.userChangePassword.notFound.message": "Tämä käyttäjä on poistettu.",
  "cp.pages.userChangePassword.notFound.title": "Käyttäjää ei löydy.",
  "cp.pages.userChangePassword.successSnackbar": "Salasana vaihdettu",
  "cp.pages.userChangePassword.title": "Vaihda salasana",
  "cp.pages.userChangePassword.wrongPasswordSnackbar": "Nykyinen salasana on väärä",
  "cp.pages.userDetails.errorSnackbar": "Kutsua ei voitu lähettää. ",
  "cp.pages.userDetails.invitation": "Kutsu",
  "cp.pages.userDetails.notFound.message": "Nämä tiedot poistettiin. ",
  "cp.pages.userDetails.notFound.title": "Ei löydetty",
  "cp.pages.userDetails.sendInvitation": "Lähetä kutsu",
  "cp.pages.userDetails.signUpAccepted": "Hyväksytyt",
  "cp.pages.userDetails.signUpPending": "Vireillä",
  "cp.pages.userDetails.successSnackbar": "Kutsu lähetetty",
  "cp.pages.userDetails.userDetailsEmail": "Sähköposti"
}